import { useEffect } from "react";
import { useLocation } from "react-router-dom";


export default function RouteWatcher() {
  const location = useLocation();

  useEffect(() => {
    window.parent.postMessage(
      { type: "CURRENT_URL", url: window.location.href },
      "*"
    );
  }, [location]);

  return null;
};
